import React from "react";
import ico_arrow_back from "@src/assets/ico_arrow_back.png";
import { css } from "@emotion/react";
import InfoStep1 from "./ui/icon/InfoStep1.png";
import InfoStep2 from "./ui/icon/InfoStep2.png";
import styled from "styled-components";
import { transferToNative } from "@src/lib/WebAppBridge";
import { useNavigate } from "react-router-dom";

const ArchitectInformation = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        transferToNative("done", "closeWebView");
    };

    return (
        <Layout>
            <Header>
                <div className="prevBtn" onClick={handleBack}>
                    <img src={ico_arrow_back} alt="뒤로가기" />
                </div>
                <div className="content">
                    <span>건축사 광고 서비스</span>
                </div>
            </Header>

            <div css={noticeContainerStyle}>
                <div css={TitleStyle}>
                    건축사 광고는
                    <br />
                    <span style={{ fontWeight: "normal", fontSize: "18px" }}>이렇게 진행돼요!</span>
                </div>
                <div css={ContentContainerStyle}>
                    {/* Step1 */}
                    <div className="stepBox">
                        <img src={InfoStep1} alt="consulting" className="stepIcon" width={50} height={50} />
                        <p css={BlackTitleStyle}>
                            <span css={BlackStepStyle}>step.01</span> 광고 등록하기
                        </p>
                        <div css={BlueBoxStyle}>
                            <p css={BlackSubTitleStyle}>
                                선택한 읍/동의 모든 필지 상세에 <br /> 건축사 광고를 등록하는 서비스에요.
                            </p>
                            <p css={BlackContentStyle} style={{ margin: "8px 0" }}>
                                ✔️ 광고 비용 : 8만원 <br />
                                ✔️ 기간 : 1개월 (매월 8만원) <br /> <br />
                                <b style={{ fontSize: "15px" }}>☝️ 광고 효과</b>
                                <ul css={bulletListStyle}>
                                    <li>전국 약 4천만 개의 필지 광고 가능</li>
                                    <li>선택한 지역 내 잠재 고객에게 한 달 동안 지속적인 노출</li>
                                    <li>건축 서비스를 찾는 고객들에게 직접적인 홍보 효과</li>
                                    <li>지역 기반 타겟팅으로 효율적인 마케팅 가능</li>
                                </ul>
                            </p>
                            <div css={dividerStyle} style={{ margin: "8px 0" }} />

                            <div css={FlexColumnStyle} style={{ marginTop: "24px" }}>
                                <div>
                                    <p css={BlueTitleStyle}>❶ 광고하고 싶은 지역 선택</p>
                                    <p css={GreyContentStyle} style={{ marginLeft: "20px", marginTop: "8px" }}>
                                        <ul css={bulletListStyle}>
                                            <li>도시 지역 : 동 단위로 선택</li>
                                            <li>그 외 지역 : 읍 단위로 선택</li>
                                        </ul>
                                    </p>
                                </div>
                                <div>
                                    <p css={BlueTitleStyle}>❷ 결제하기 </p>
                                    <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                        월 3만원으로 선택한 동/읍 필지 상세에 <br /> 건축사광고를 등록할 수 있어요.
                                    </p>
                                </div>
                                <div>
                                    <p css={BlueTitleStyle}>❸ 프로필 등록</p>
                                    <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                        광고에 노출될 프로필 사진과 건축사무소 정보를 입력해요.
                                    </p>
                                </div>
                                <div>
                                    <p css={BlueTitleStyle}>❹ 등록 완료 </p>
                                    <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                        등록하기 버튼 클릭 시, 광고가 시작되며 한달동안 유지돼요. <br />
                                        <br />※ 환불 정책 : 결제 후 취소는 가능하지만 광고등록이 완료된 후에는 환불이 불가해요.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step2 */}
                    <div className="stepBox">
                        <img src={InfoStep2} alt="bidAgent" className="stepIcon" width={50} height={50} />
                        <p css={BlackTitleStyle}>
                            <span css={BlackStepStyle}>step.02</span> 광고 관리
                        </p>
                        <div css={BlueBoxStyle}>
                            <p css={GreyContentStyle} style={{ margin: "0px 0 8px 0" }}>
                                <ul css={bulletListStyle}>
                                    <li>등록 후 한달 동안 자동으로 광고가 노출됩니다.</li>
                                    <li>필요 시 프로필 정보 업데이트 가능합니다.</li>
                                    <li>광고 연장은 만료 전 재결제로 가능합니다.</li>
                                </ul>
                            </p>
                            <p css={BlackContentStyle}>
                                <span style={{ fontWeight: "bold" }}>
                                    지금 바로 &quot;광고 등록하기&quot; 버튼을 클릭하여 <br /> 귀하의 건축사 사무소를 효과적으로
                                    홍보하세요!
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <BottomArea>
                <NextButton onClick={() => navigate("/advertisement-architect/selecter")} $active={true}>
                    광고할 지역 선택하기
                </NextButton>
            </BottomArea>
        </Layout>
    );
};

export default ArchitectInformation;

const Layout = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    height: calc(var(--vh, 1vh) * 100);
    background: #ffffff;
`;

const Header = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 56px;
    height: 56px;
    padding: 14px;

    .prevBtn {
        position: absolute;
        left: 5px;
        top: 10px;
        width: 40px;
        height: 40px;
        padding: 10px;
        cursor: pointer;

        & > img {
            width: 10px;
            height: 17px;
        }
    }

    .content {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
        color: #0c002c;
    }
`;

const noticeContainerStyle = css`
    width: 100%;
    padding: 30px 14px 0px 14px;
    overflow-y: auto;
    height: 100vh;
`;

const TitleStyle = css`
    color: #0c002c;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.4;
    text-align: left;
    margin-bottom: 28px;
`;

const ContentContainerStyle = css`
    padding-left: 30px;
    margin-left: 24px;
    border-left: 2px solid #efefef;

    .stepBox {
        position: relative;
    }

    .stepIcon {
        position: absolute;
        top: -13px;
        left: -56px;
    }
`;

const BlueBoxStyle = css`
    width: 100%;
    padding: 14px;
    background-color: #eff8ff;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 24px;
`;

const LightGrayBoxStyle = css`
    width: 100%;
    padding: 14px;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 24px;
`;

const BlueTitleStyle = css`
    color: #2275ee;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.2;
`;

const BlackTitleStyle = css`
    color: #282828;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.4;
`;

const BlackSubTitleStyle = css`
    color: #382e51;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 14px;
`;
const BlackStepStyle = css`
    color: #282828;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 8px;
`;

const BlackContentStyle = css`
    color: #3c3c3c;
    font-size: 13px;
    line-height: 1.4;
`;

const bulletListStyle = css`
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 1.25em;

    & > li {
        list-style-type: disc;
        list-style-position: outside;
        display: list-item;
    }
`;

const GreyContentStyle = css`
    color: #8d8d8d;
    font-size: 13px;
    line-height: 1.4;
`;

const dividerStyle = css`
    width: 100%;
    height: 1px;
    background-color: #e8e8e8;
    margin-top: 14px;
    margin-bottom: 14px;
`;

const FlexColumnStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
`;

const BottomArea = styled.div`
    padding: 10px 14px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    background: #ffffff;
`;

const NextButton = styled.button<{ $active: boolean }>`
    width: 100%;
    height: 52px;
    border-radius: 12px;
    border: none;
    background: ${({ $active }) => ($active ? "#2275EE" : "#D4D4D8")};
    cursor: ${({ $active }) => ($active ? "pointer" : "default")};
    transition: all 0.15s ease;

    color: #ffffff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
`;
